module.exports = __webpack_public_path__ + "img/batch-directive.6e3f61ed.png";